import React, { Component } from 'react';
import styled from 'styled-components';

import { SnackbarService } from '@services';

import Snackbar from './snackbar';

class SnackbarWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      snacks: [],
      queue: [],
    };
  }

  componentDidMount() {
    // RxJS Subscribe
    this.subscription = SnackbarService.getSnackbar()
      .subscribe(({ type, message }) => {
        this.addSnackbar(message, type);
      });
  }

  componentWillUnmount() {
    // RxJS Unsubscribe
    this.subscription.unsubscribe();
  }

  generateId = () => {
    const ALPHABET = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const ID_LENGTH = 8;

    let randomId = '';
    for (let i = 0; i < ID_LENGTH; i++) {
      randomId += ALPHABET.charAt(Math.floor(Math.random() * ALPHABET.length));
    }
    return randomId;
  };

  addSnackbar = (message = 'Default Message', type = 'default') => {
    let { snacks, queue } = this.state;
    let id = this.generateId();

    let snack = (
      <Snackbar
        id={id}
        key={id}
        variant={type}
        message={message}
        removeSnack={this.removeSnack}
      />
    );

    if (snacks.length === 5) {
      queue.push(snack);
      this.setState({ queue });
    } else {
      snacks = [...snacks, snack];
      this.setState({ snacks });
    }
  };

  snackFromQueue = (Component, filteredSnacks) => {
    let newSnacks = [...filteredSnacks, Component];
    return newSnacks;
  };

  removeSnack = (index) => {
    let { snacks, queue } = this.state;
    let filtered = snacks.filter((item) => item.props.id !== index);

    if (queue.length > 0) {
      let newSnacks = this.snackFromQueue(queue.shift(), filtered);
      this.setState({ snacks: newSnacks });
    } else {
      this.setState({ snacks: filtered });
    }
  };

  render() {
    const { snacks } = this.state;

    return (
      <Styled.SnackbarWrapper>
        {snacks}
      </Styled.SnackbarWrapper>
    );
  }
}

// *************************************
// STYLED COMPONENTS
// *************************************

const Styled = {};

Styled.SnackbarWrapper = styled.div`
  top: 24px;
  right: 0px;
  left: auto;
  margin-right: 24px;
  position: absolute;
  z-index: 9999999;
  transition: all 1s ease;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  -ms-transition: all 1s ease;
  -o-transition: all 1s ease;
`;

export default SnackbarWrapper;
